export default function Unanswered({ data }) {
  if (!data) return null;
  const {
    unanswered = [],
    by_topic_last_30_days: byTopic = [],
    by_source_last_30_days: bySource = [],
  } = data;

  return (
    <section className="card">
      <h2>Frågor som inte fick svar</h2>
      <p className="hint">
        Elevernas frågor sparas inte i text. Ämnet är en etikett ur en lista som
        Aerro definierat — inte elevens egna ord.
      </p>

      {/* Ämnet först. "Frånvaro: 14 obesvarade" är en beställning; en lista med
          fjorton rader att bläddra igenom är en observation. */}
      {byTopic.length > 0 && (
        <>
          <h3>Vad eleverna frågar om, senaste 30 dagarna</h3>
          <ul className="tally">
            {byTopic.map((row) => (
              <li key={row.topic || "oklassificerad"}
                  className={row.unclassified ? "unclassified" : undefined}>
                <span className="count">{row.unanswered}</span> {row.label}
                {row.unclassified && (
                  <span className="hint"> — ingen kategori passade</span>
                )}
              </li>
            ))}
          </ul>
          {byTopic.some((r) => r.unclassified) && (
            <p className="hint">{data.unclassified_means}</p>
          )}
        </>
      )}

      {bySource.length > 0 && (
        <>
          <h3>Dokument som hämtades men inte räckte</h3>
          <ul className="tally">
            {bySource.map((row) => (
              <li key={row.source}>
                <span className="count">{row.unanswered}</span> {row.source}
              </li>
            ))}
          </ul>
        </>
      )}

      {unanswered.length === 0 ? (
        <p className="empty">Inga obesvarade frågor än.</p>
      ) : (
        <table>
          <thead>
            <tr><th>När</th><th>Ämne</th><th>Hämtade dokument</th><th>Poäng</th></tr>
          </thead>
          <tbody>
            {unanswered.map((row, index) => (
              <tr key={index}>
                <td>{new Date(row.at).toLocaleString("sv-SE")}</td>
                <td>{row.topic_label || <span className="hint">oklassificerad</span>}</td>
                <td>{row.sources.slice(0, 3).join(", ") || "—"}</td>
                <td>{row.best_score == null ? "—" : row.best_score.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
